import TextField from "@mui/material/TextField";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { inputClasses } from "@mui/material/Input";
import { styled } from "@mui/material/styles";

import { COLOR_SECOND, COLOR_NEUTRAL_LIGHT } from "../../commons/LaColors";

const StyledTextField = styled(TextField)({
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: COLOR_NEUTRAL_LIGHT,
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: COLOR_SECOND,
    },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: COLOR_SECOND,
    },
  //[`& .${outlinedInputClasses.input}`]: {
  //  color: COLOR_SECOND,
  //},
  //[`&:hover .${outlinedInputClasses.input}`]: {
  //  color: COLOR_SECOND,
  //},
  //[`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.input}`]:
  //  {
  //    color: COLOR_NEUTRAL_STRONG,
  //  },
  [`& .${inputLabelClasses.outlined}`]: {
    fontSize: 14,
  },
  [`&:hover .${inputLabelClasses.outlined}`]: {
    color: COLOR_SECOND,
    fontSize: 14,
  },
  [`& .${inputLabelClasses.outlined}.${inputLabelClasses.focused}`]: {
    color: COLOR_SECOND,
    fontSize: 14,
  },
  [`& .${inputClasses.root}`]: {
    fontSize: 14,
  },
  [`&:hover .${inputClasses.root}`]: {
    color: COLOR_SECOND,
    fontSize: 14,
  },
  [`& .${inputClasses.root}.${inputClasses.focused}`]: {
    color: COLOR_SECOND,
    fontSize: 14,
  },
});

export default StyledTextField;
